export default class Ai {
  constructor(cscom) {
    if (!(this instanceof Ai)) {
      return new Ai(cscom);
    }
    this.cscom = cscom;
  }

  promptCubeJsQuestion(question) {
    return this.cscom.req.post("/api/rest/talink/ai/prompt-cubejs-question", {
      question,
    });
  }

  promptCubeJsSchema(question) {
    return this.cscom.req.post("/api/rest/talink/ai/prompt-cubejs-schema", {
      question,
    });
  }

  completions(question) {
    return this.cscom.req.post("/api/rest/talink/cube/ai/completions", {
      messages: [
        {
          role: "user",
          message: question,
        },
      ],
    });
  }

  chat(question) {
    return this.cscom.req.get("/api/rest/talink/cube/ai/chat", {
      question,
    });
  }

  getChat(id) {
    return this.cscom.req.get(`/api/rest/talink/cube/ai/chats/${id}`);
  }

  recentChats() {
    return this.cscom.req.get("/api/rest/talink/cube/ai/recent-chats");
  }

  deleteChat(id) {
    return this.cscom.req.del(`/api/rest/talink/cube/ai/chats/${id}`);
  }
}
